import { Clock } from "lucide-react";

import HorarioOpcoes from "../HorarioOpcoes";
import Cartao from "./Cartao";

/** Passo 5: só com a loja aberta (pelo horário de funcionamento) ou o dia todo. */
export default function SecaoQuando({ a }) {
  const horario = a.dados.horario || { tem: false, dias: [] };
  const modo = a.form.horarioModo;
  return (
    <Cartao numero={5} titulo="Quando aparece" icone={Clock} e2e="impulsionar-quando"
      descricao="Anunciar com a loja fechada gasta dinheiro com quem não consegue pedir.">
      <HorarioOpcoes modo={modo} horario={horario} aoEscolher={(m) => a.definir("horarioModo", m)} prefixo="impulsionar" />
      {modo === "funcionamento" && horario.tem && (
        <p className="text-[11px] text-muted-foreground mt-2">A Meta trabalha em horas cheias: o início arredonda para baixo e o fim para cima. Se a loja fechar mais cedo num dia, pause a campanha.</p>
      )}
      {modo === "dia_todo" && horario.tem && (
        <p className="text-xs text-amber-600 mt-2" data-e2e="impulsionar-aviso-dia-todo">Assim o anúncio aparece também com a loja fechada. Dá para trocar depois, no cartão da campanha.</p>
      )}
    </Cartao>
  );
}
